import { Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxBorder, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { Transaction } from '../../../../../../../../../store/transactionFlow/types';
import { getCodedColor, TransactionFields } from '../../../../constants';

interface TransactionCardProps {
  item: Transaction;
  infos: TransactionFields[];
  onSelectClient?: (cpfCnpj: string) => void;
}

export const TransactionCard = ({ item, infos, onSelectClient }: TransactionCardProps) => (
  <Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['inset.sm']}>
    <VStack space={Spacing['stack.xxxs']}>
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
        <FlatList
          key="mobile-asset-principal-card-flat-list"
          style={{ overflow: 'visible' }}
          keyExtractor={(info) => info.key as string}
          columnWrapperStyle={{
            justifyContent: 'space-between',
            paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
          }}
          data={infos}
          numColumns={4}
          renderItem={({ item: info }) => (
            <VStack
              justifyContent="space-between"
              alignContent="center"
              space={Spacing['inline.quarck']}
              minW={120}>
              <Text fontSize={Typography['fontsize.xs']} variant="semibold" color="neutral.black">
                {info.label}
              </Text>
              {info.key === 'value' ? (
                <Text fontSize={Typography['fontsize.md']} color={getCodedColor(item[info.key])}>
                  {`${Utils.Mask.Money(item[info.key])}`}
                </Text>
              ) : info.key === 'clientName' ? (
                <Pressable onPress={() => onSelectClient?.(item.clientDocument)}>
                  <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
                    {`${item[info.key]}`}
                  </Text>
                </Pressable>
              ) : (
                <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
                  {`${item[info.key]}`}
                </Text>
              )}
            </VStack>
          )}
        />
      </HStack>
    </VStack>
  </Shadow>
);
